<template>
  <div id="app">
        <component v-bind:is="component" v-on:authfail="doAuthFail" v-on:login="doLogin"></component>      
  </div>
</template>

<script>
import Join from './components/Join.vue'
import MainScreen from './components/MainScreen.vue'



export default {
  name: 'App',
  components: {
    MainScreen,
    Join
  }, 
  data:  function () {
    return {      
      gameId:"1RDXVL",
      userId:"",      
      component:"Join",
      colour: {}
    }
  },
  methods: {
    doAuthFail () {
    	console.log("doAuthFail");
      	this.component = "Join";
    },
    doLogin () {
    	console.log("doLogin for userId:" + this.userId + ", gameId: " + this.gameId + " hostId: " + this.hostId  + " color:" + this.colour);
    	
    	if (!this.colour.hex){
    		this.colour.hex = this.randomColor(100)
   		}
   		
      	this.component = "MainScreen";
    },
    randomColor(brightness) {
		  function randomChannel(brightness){
		    var r = 255-brightness;
		    var n = 0|((Math.random() * r) + brightness);
		    var s = n.toString(16);
		    return (s.length==1) ? '0'+s : s;
		  }
		  return '#' + randomChannel(brightness) + randomChannel(brightness) + randomChannel(brightness);    
    }
    
  },
  
}
</script>

<style>
body{margin: 0px;}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  

}
</style>
